import type { Practitioner } from 'fhir/r4';
import { FHIRModel } from './fhir-model';

export class PractitionerModel extends FHIRModel<Practitioner> {
  public kind = 'Practitioner' as const;

  public get fullName(): string {
    const firstEntryInName = this.resource.name?.[0];
    const givenName =
      firstEntryInName?.given && firstEntryInName.given.length > 0 ? firstEntryInName.given[0] : '';

    return [givenName, firstEntryInName?.family].filter((n) => n).join(' ');
  }

  public get title() {
    return this.fullName;
  }
}
